module.exports = __webpack_public_path__ + "media/dashboard/assets/images/octo_img-838dfbd4ca929068581a52b0d5ba02ba.png";